<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<figure class="media-upload-image-figure">
  <img
    *ngIf="uploadedImage"
    class="image"
    [class.collage-image]="collage"
    [src]="url"
    width="960"
    height="360"
    [attr.aria-label]="
      link && !unavailable
        ? !!uploadedImage
          ? (caption ?? ('translations.global.ariaLabels.previewImage' | transloco))
          : ('translations.global.ariaLabels.uploadImage' | transloco)
        : null
    "
    [class.link]="link && !unavailable"
    [alt]="
      unavailable
        ? ('translations.global.imageUnavailable' | transloco)
        : (caption ? caption : '') + (link ? ' Press enter to open image url ' + link : '')
    "
    (click)="link && !unavailable ? onImageClick() : null"
    (keydown.enter)="link && !unavailable ? onImageClick() : null"
    ogImageFallback
    [ogImageFallback]="originalUrl"
    (imageUnavailable)="onUnavailable()"
  />
  <figcaption *ngIf="caption" class="media-upload-image-caption">{{ caption }}</figcaption>
</figure>
